import styled from 'styled-components';

export const srOnlyFocusableStyles = `
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0px;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  border: 0;
  :hover {
    position: static;
    width: auto;
    height: auto;
    margin: 0px;
    overflow: visible;
    clip: auto;
  }
  :focus {
    position: static;
    width: auto;
    height: auto;
    margin: 0px;
    overflow: visible;
    clip: auto;
  }
`;

export const SrOnlyText = styled.span`
  ${srOnlyFocusableStyles}
`;

export default SrOnlyText;
